/*
 * The session token and session events. The mock API issues a bearer token; the real API may switch to an
 * HttpOnly cookie, in which case only this file and client.ts change.
 */
import { storage } from '@/lib/storage'

const KEY = 'bpanel.session'

export const authToken = {
  get: (): string | null => storage.get(KEY),
  set: (token: string) => storage.set(KEY, token),
  clear: () => storage.remove(KEY),
}

type Listener = () => void
const expiredListeners = new Set<Listener>()

/** Fired when an authenticated request comes back 401 while a token is held: the session expired. */
export const sessionEvents = {
  onExpired(fn: Listener): () => void {
    expiredListeners.add(fn)
    return () => expiredListeners.delete(fn)
  },
  emitExpired() {
    expiredListeners.forEach((fn) => fn())
  },
}
